import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router';

// Views
const HomeView = () => import(/* webpackChunkName: "home" */ '../views/HomeView.vue');
const Cart = () => import(/* webpackChunkName: "cart" */ '../views/Cart.vue');
const PaymentRedirect = () => import(/* webpackChunkName: "payment" */ '../views/PaymentRedirect.vue');
const NotFound = () => import(/* webpackChunkName: "not-found" */ '../views/NotFound.vue');

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/cart',
    name: 'cart',
    component: Cart
  },
  {
    path: '/payment',
    name: 'payment',
    component: PaymentRedirect
  },
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: NotFound,
  },
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router;
